var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.27,
    height: 38,
    viewBox: "0 0 35.27 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M146.648,138.72l.016-.016a.6.6,0,0,0,.062-.085c.008-.008.008-.015.016-.023.016-.031.039-.062.054-.093a.027.027,0,0,1,.008-.015c.016-.031.031-.062.047-.1,0-.008,0-.008.008-.016.016-.031.023-.07.039-.109,0-.008,0-.016.008-.016a.544.544,0,0,0,.023-.109.07.07,0,0,1,.008-.039c.008-.031.008-.062.016-.093a1.13,1.13,0,0,0,0-.264.388.388,0,0,0-.016-.093.07.07,0,0,0-.008-.039c-.008-.039-.016-.07-.023-.109,0-.008,0-.016-.008-.016a.608.608,0,0,0-.039-.109c0-.008,0-.008-.008-.016-.016-.031-.031-.07-.047-.1a.027.027,0,0,0-.008-.015.579.579,0,0,0-.054-.093c-.008-.008-.008-.015-.016-.023a.819.819,0,0,0-.062-.085l-.016-.016a1.1,1.1,0,0,0-.093-.1l-7.671-7.664A1.333,1.333,0,0,0,137,131.15l5.4,5.4H120.934a1.33,1.33,0,1,0,0,2.661H142.4l-5.36,5.36a1.33,1.33,0,1,0,1.877,1.885l7.625-7.625C146.586,138.782,146.617,138.751,146.648,138.72Z",
    transform: "translate(-111.688 -118.879)",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M24.821,2.661H34.75A1.33,1.33,0,1,0,34.75,0H24.821A7.233,7.233,0,0,0,17.6,7.221V30.779A7.233,7.233,0,0,0,24.821,38h9.766a1.33,1.33,0,1,0,0-2.661H24.821a4.568,4.568,0,0,1-4.561-4.561V7.221A4.568,4.568,0,0,1,24.821,2.661Z",
    transform: "translate(-17.6 0)",
    fill: "#8a8a8a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.26a20b147325c860bdbe66007eea1443.svg";
export { ForwardRef as ReactComponent };